import { FormGroup } from '@agro-club/agroclub-shared'
import env from 'env'
import { CurrencySign, Hedges } from 'modules/domain/export/types'
import { FormikFieldsType } from 'modules/domain/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { DatePicker } from 'views/components/DatePicker/DatePicker'
import { FormInput } from 'views/components/form/FormInput'
import { FormCurrencySelect } from 'views/components/FormCurrencySelect/FormCurrencySelect'
import { SharedModalInputs } from 'views/components/SharedModal'

export type HedgingFields = Nullable<Omit<Hedges, 'id' | 'bank_deal_number' | 'expiration_date'>>

const currency = env.REACT_APP_CURRENCY_SYMBOL

type Props = {
  formik: FormikFieldsType
}

export const CommonForwardFields: FC<Props> = ({ formik }) => {
  const { t } = useTranslation('export')

  const formCurrencyId = formik.values.currency

  return (
    <SharedModalInputs>
      <FormCurrencySelect label={t('currency')} formik={formik} field="currency" />
      <FormInput
        formik={formik}
        field="option_volume"
        label={`${t('forwardSum')}, ${CurrencySign[formCurrencyId]}`}
        type="number"
      />
      <FormInput
        formik={formik}
        field="strike"
        label={`${t('rate')}, ${t('currencyPerCurrency', { currency, perCurrency: CurrencySign[formCurrencyId] })} `}
        type="number"
      />
      <FormGroup label={t('dealDate')} error={formik.errors.settlement_date}>
        <DatePicker
          value={formik.values.settlement_date}
          onChange={(data) => formik.setFieldValue('settlement_date', data['date'])}
          error={!!formik.errors.settlement_date}
          placeholder={t('common:datePlaceholder')}
        />
      </FormGroup>
      <FormInput formik={formik} field="option_bonus" label={`${t('marginSum')}, ${currency}`} type="number" />
      <FormGroup label={t('plannedDateReceiptMoney')} error={formik.errors.signed_date}>
        <DatePicker
          value={formik.values.receipt_planned_date}
          onChange={(data) => formik.setFieldValue('receipt_planned_date', data['date'])}
          error={!!formik.errors.receipt_planned_date}
          placeholder={t('common:datePlaceholder')}
        />
      </FormGroup>
    </SharedModalInputs>
  )
}
